<template>
    <div class="microlearning-materials">
        <template v-if="isLoggedIn && !isDemo">
            <h1 class="microlearning-materials__title" v-html="$t('MicroLearning.assignment')"></h1>
            <span class="microlearning-materials__description" v-html="materialTabDescription"></span>
            <ul class="microlearning-materials__list">
                <li
                    class="microlearning-materials__item"
                    v-for="(assignmentFile, index) in microLearningSection.files"
                    :key="index"
                >
                    <span class="microlearning-materials__item-title">
                        <span class="icon-file-text"></span>
                        <span>{{ getAssignmentFileNameFromUrl(assignmentFile) }}</span>
                    </span>
                    <TotemLink
                        icon="download"
                        color="secondary"
                        class="microlearning-materials__link"
                        target="_blank"
                        size="medium"
                        :href="assignmentFile"
                        :label="$t('MicroLearning.download')"
                    />
                </li>
            </ul>
        </template>
        <template v-else>
            <span v-html="$t('MicroLearning.materials_not_available_for_non_logged')"></span>
        </template>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'MicroLearningCourseMaterials',
        props: {
            materialTabDescription: String,
            isLoggedIn: Boolean,
            isDemo: Boolean
        },
        computed: {
            ...mapGetters({
                microLearningSection: 'MicroLearning/getMicroLearningSection',
            }),
        },
        methods: {
            getAssignmentFileNameFromUrl(url) {
                return url.split('/').pop().split('?')[0]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .microlearning-materials {
        display: flex;
        flex-direction: column;
        background: $white;
        margin: 0 0 20px;
        border-radius: 20px;
        min-height: 620px;
        padding: 30px;
        border: 1px solid $alto;


        [class*="mobile"] & {
            min-height: 208px;
        }

        &__title {
            font-size: 2.4rem;
            margin: 0 0 20px;
        }

        &__item-title {
            font-size: 1.8rem;
            .icon-file-text {
                margin: 0 10px 0 0;
            }
        }

        &__description {
            font-size: 1.8rem;
            margin: 0px 0 20px 0;
        }

        &__list {
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid $alto;
        }

        &__item {
            justify-content: space-between;
            display: flex;
            padding: 16px 8px;
            align-items: center;
        }
    }
</style>
